export enum ApplicationInviteType {
  APPLICANT = 'Applicant',
  CO_APPLICANT = 'Co-Applicant',
  CO_SIGNER = 'Co-Signer',
}
